import React, { useState } from "react";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";

import CountryFlagName from "./CountryFlagName";

function SendMoneySelectionInput(props) {
  const {
    title,
    availableCountries,
    inputFieldRef,
    getSelectedCountry,
    availableServices,
    selectedService,
    setSelectedService,
  } = props;

  const [countries, setCountries] = useState(availableCountries);

  const [openDropdown, setOpenDropdown] = useState(false);
  const [placeholderText, setPlaceholderText] = useState("Select...");

  const [selectedCountry, setSelectedCountry] = useState([]);

  const onListItemSelection = (e) => {
    const sCountry = availableCountries.filter(
      (sc) => sc.name === e.target.dataset.countryname
    );

    setSelectedCountry(sCountry);
    setPlaceholderText("");
    setOpenDropdown(false);
    inputFieldRef.current.value = "";
    getSelectedCountry(title, sCountry);
    setCountries(availableCountries);
  };

  const handleInputClick = () => {
    setOpenDropdown(true);
    setPlaceholderText("");
    setSelectedCountry([]);
  };

  const handleChange = (e) => {
    //let name = e.target.name;
    let value = e.target.value;
    if (title) {
      if (value.length > 0) {
        let match = countries.filter((c) =>
          c.name.toLowerCase().startsWith(value.toLowerCase())
        );
        setCountries(match);
      } else {
        setCountries(availableCountries);
      }
    } else {
      e.target.value = "";
    }
  };

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const onClickSerivesListItem = (service) => {
    setSelectedService(service);
    setOpenDropdown(false);
  };

  return (
    <div style={{ flexBasis: "100%" }}>
      <h2 className="fs-6 text-dark mx-2">{title}</h2>
      <div className="position-relative rounded-pill bg-white mx-2 px-2 py-2 d-flex align-item-center justify-content-between mb-3">
        <div className="position-relative w-100 bg-success d-flex align-items-center">
          <div className="position-absolute start-0 top-0 w-100 full-height bg-white d-flex align-items-center">
            {title && (
              <>
                {selectedCountry.length > 0 ? (
                  <CountryFlagName
                    countryFlag={selectedCountry[0].flag}
                    countryName={selectedCountry[0].name}
                  />
                ) : (
                  <p className="mb-0">{placeholderText}</p>
                )}
              </>
            )}
            {!title && (
              <>
                {selectedService ? (
                  <CountryFlagName countryName={selectedService} />
                ) : (
                  <p className="mb-0">{placeholderText}</p>
                )}
              </>
            )}
          </div>
          <input
            ref={inputFieldRef}
            type="text"
            name="sendTo"
            onChange={handleChange}
            onClick={handleInputClick}
            className="position-relative z-index-to-5fs-14 w-100 border-0 bg-transparent outline-none d-block"
          />
        </div>
        <div className="d-flex align-item-center">
          <div className="full-height border me-3"></div>
          <button
            onClick={handleOpenDropdown}
            className="btn btn-trasnparent p-0 d-flex align-items-center boxshadow-none"
          >
            {openDropdown ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
          </button>
        </div>
        <div
          className={
            openDropdown
              ? "position-absolute start-0 top-100 pt-3 mt-3 bg-white rounded-10 w-100 overflow-auto max-height-180 z-index-to-5"
              : "d-none"
          }
        >
          {title && (
            <ul className="unstyled-list p-0 mx-3">
              {countries.map((c) => (
                <li
                  key={c.name}
                  onClick={onListItemSelection}
                  data-countryname={c.name}
                  className={`d-flex align-items-center py-2 px-3 rounded-pill bg-white mb-2 cursor-pointer ${
                    selectedCountry.length > 0 &&
                    selectedCountry[0].name === c.name
                      ? "active-list-item"
                      : "light-primary"
                  }`}
                >
                  <CountryFlagName countryFlag={c.flag} countryName={c.name} />
                </li>
              ))}
            </ul>
          )}
          {availableServices && (
            <ul className="unstyled-list p-0 mx-3">
              {availableServices.map((service) => (
                <li
                  key={service}
                  onClick={() => onClickSerivesListItem(service)}
                  className={`d-flex align-items-center py-2 px-3 rounded-pill bg-white mb-2 cursor-pointer ${
                    selectedService === service
                      ? "active-list-item"
                      : "light-primary"
                  }`}
                >
                  <CountryFlagName countryName={service} />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default SendMoneySelectionInput;
